import { render, staticRenderFns } from "./ThirdPartyForm.vue?vue&type=template&id=2b4451d5"
import script from "./ThirdPartyForm.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyForm.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyForm.vue?vue&type=style&index=0&id=2b4451d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports